<template>
  <grid 
    :data-items="result"
    :columns="columns">
  </grid>
</template>
<script>
import { Grid } from '@progress/kendo-vue-grid'
import { process } from '@progress/kendo-data-query'

export default {
  components: {
    grid: Grid
  },
  props: {
    dataItem: Object
  },
  data () {
    return {
      products: [
        {
          Accion: 'Creación',
          Estado: 'Correcto',
          Error: '',
        }, 
        {
          Accion: 'Vinculación',
          Estado: 'Error',
          Error: 'Límite de licenciamiento',
        }
      ],
      columns: [
        { field: 'Accion', title: 'Acción', width: '100px' },
        { field: 'Estado', title: 'Estado', width: '100px' },
        { field: 'Error', title: 'Error' },
      ],
      result: null,
    }
  },
  created () {
    console.log('created')
  },
  mounted () {
    console.log('mounted')
    this.getFilteredProducts()
  },
  methods: {
    getFilteredProducts () {
      const dataState = {
        skip: 0,
        take: 10,
        sort: [],
        group: [],
      }
      this.result = process(this.products, dataState)
    }
  },
  computed: {
  }
}
</script>
